export const STRIPE_EMBEDDED_CHECKOUT_ELEMENT_ID = 'stripe-checkout';
